import {
  Component,
  EventEmitter,
  inject,

  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Combustiveis } from '../model/RetornoGetCombustiveis';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-modal-ajuste-preco-unitario',
  templateUrl: './modal-ajuste-preco-unitario.component.html',
  styleUrls: ['./modal-ajuste-preco-unitario.component.scss'],
})
export class ModalAjustePrecoUnitarioComponent implements OnInit {
  @Input() combustivel: Combustiveis | null = null;
  @Output() salvarModificacoes = new EventEmitter<boolean>();

  private modalService = inject(NgbModal);
  private closeResult = '';
  private precoUnitario =  0
  private precoUve = 0
  private precoRedeEspecial = 0
  private descontoUve = 0
  private descontoRedeEspecial = 0

  public precoUnitarioForm = new FormGroup({
    dataInicio: new FormControl(''),
    datCadastro: new FormControl(''),
    dscStatusAcordo: new FormControl(''),
    descricaoCombustivel: new FormControl(''),
    tituloBomba: new FormControl('Preço na bomba'),
    descricaoBomba: new FormControl('Preço na bomba'),

    precoBomba: new FormControl(0),
    precoRedeEspecial: new FormControl(0),
  });

  ngOnInit(): void {
    
    this.precoUnitarioForm.patchValue({
      dataInicio: this.combustivel?.combustivel.datInicio,
      datCadastro: this.combustivel?.combustivel.datCadastro,
      dscStatusAcordo: this.combustivel?.combustivel.dscStatusAcordo,
      descricaoCombustivel: this.combustivel?.descricaoCombustivel,
      tituloBomba: this.combustivel?.combustivel.precos.precoUnitario[0].titulo,
      descricaoBomba:
        this.combustivel?.combustivel.precos.precoUnitario[0].descricao,
      precoBomba: this.combustivel?.combustivel.precos.precoUnitario[0].preco,
    });

    this.precoUnitario = this.combustivel?.combustivel.precos.precoUnitario[0].preco || 0;
    this.precoUve = this.combustivel?.combustivel.precos.precoNegociado[0].preco || 0;
    this.precoRedeEspecial = this.combustivel?.combustivel.precos.precoRedeEspecial[0].preco || 0;

    this.descontoUve = this.precoUnitario - this.precoUve;
    this.descontoRedeEspecial = this.precoUnitario - this.precoRedeEspecial;

  }

  open(content: any) {
    this.modalService
      .open(content, {
        windowClass: 'custom-window-class',
        ariaLabelledBy: 'modal-basic-title',
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  salvarModificacoesCombustivel(valor: boolean): void {
    if (this.combustivel !== null) {
      const precoBomba = this.precoUnitarioForm.get('precoBomba')?.value || 0;

      this.combustivel.combustivel.precos.precoUnitario[0].preco = precoBomba;
      this.combustivel.combustivel.precos.precoNegociado[0].preco = precoBomba - this.descontoUve;
      this.combustivel.combustivel.precos.precoRedeEspecial[0].preco = this.descontoRedeEspecial;
    }
    this.salvarModificacoes.emit(valor);
  }
}


